<template>
  <div class="content_all2" id="account_info">
    <div class="content_box">
      <div class="list_box2">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"><strong>主旨：提供臺大體育室戶外場地、舊體育館線上訂位系統&nbsp;<br></strong></font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"></span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">說明：
          <br>
          <br>一、體育室目前所提供之「線上訂位系統」，可透過網路預約體育室戶外場地、舊體育館。
          <br>二、提供校內團體使用以解決平日排隊預約之不便，包括校內行政單位、系所學會、校隊、社團。
          <br>
        </font>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"><strong style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
          <font color="maroon">體育室「體育館及戶外場地線上訂位系統」簡介：</font>
        </strong>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">&nbsp;</span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">一、簡介</font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">&nbsp;</span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="#696969" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
          <br>
          <font color="black">1. 因應網際網路發達普及，校內服務亦隨之日趨網路化，許多申請查詢等等傳統式紙上作業，在校內各單位的共同努力之下，也已發展出網路版，俾能提昇工作效率，加速資訊傳遞，以及減少傳統作業的往返人力負擔。此外，以往每月二十五日學生社團為了爭取到場地使用往往徹夜排隊於舊體育館門口，為了減少借用團體精神、時間上耗損，特建構體育館線上訂位系統，俾能解決校內借用團體熬夜之苦。
            <br>&nbsp;
            <br>2. 依校內行政單位、系所學會、校隊、社團等單位，給定每個已申請帳號單位固定申請數量次數，並在每個月15至20日選擇時段與場地登記抽籤，並發信通知已登記單位確認，並公佈已登記者，20日以系統亂數抽籤決定中選者，並公佈抽籤結果，發信通知抽籤結果。中籤者，七日內至舊體育館辦理登記，始完成借用手續。
            <br>
          </font>&nbsp;
        </font>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">二、目前提供的帳號種類，列表如下：
          <br>
        </font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">&nbsp;</span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">1. 校內行政單位 由各分會負責人提出申請&nbsp;
          <br>
          <br>2. 校隊 由各運動代表隊隊長提出申請&nbsp;
          <br>
          <br>3. 系所學會 由各系所會負責人提出申請&nbsp;
          <br>
          <br>4. 社團 由各社團負責人提出申請&nbsp;
          <br>
        </font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"></span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">三、申請資格</font>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="#696969" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
          <font color="black">校內行政單位：由分會負責人申請帳號
            <br>
            <br>運動代表隊：以運動代表隊隊長為負責人申請帳號
            <br>
            <br>系所學會：以系所學會負責人申請帳號
            <br>
            <br>社團：以社團負責人申請帳號</font>&nbsp;
        </font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"></span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">四、申請方式</font>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">&nbsp;</span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="#696969" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
          <font color="black">1. 請上網申請：填寫校內團體帳號申請書並列印&nbsp;
            <br>
            <br>2. 攜單位章至體育室場地組確認用印後，帳號與密碼將會寄送至表格所填寫E-mail信箱</font>&nbsp;
        </font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"></span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">五、申請期限</font>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">&nbsp;</span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="#696969" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
          <font color="black">1、網路抽籤登記權限為一學年(自當年8/1至隔年7/31)&nbsp;
            <br>
            <br>2、請於每年6月1日至6月30日辦理新學年度申請作業(含舊帳號展延、新帳號申請) 逾期者將暫時停權。</font>&nbsp;
        </font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"></span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">六、帳號更改 若欲更換負責人資料，請填具申請書至舊體育館辦理&nbsp;
          <br>
        </font><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"></span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="maroon" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">七、其他疑問如對臺大體育館線上訂位系統有任何建議指教，煩請跟我們聯絡：</font>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;"><span style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">&nbsp;</span>
        <br style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
        <font color="#696969" style="font-family: Verdana, Helvetica, sans-serif; font-size: small;">
          <font color="black">1. email：
            <a href="mailto:samurai@ntu.edu.tw">
              <font color="#000000" style="background-color: inherit;">hmchang@ntu.edu.tw</font>
            </a>&nbsp;
            <br>
            <br>2. 電話諮詢：3366-9515
            <br>
            <br>3. 或親臨舊體育館辦公室</font>&nbsp;
        </font>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'account_info',
  data() {
    return {

    };
  },
  created() {

  },

  methods: {

  },
}

</script>
<style lang="scss">
#account_info {
  .account_title {
    color: rgb(128, 0, 0);
    font-weight: bold;
  }

  .account_sub {
    color: rgb(128, 0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// AccountInfo.vue?6cb437cd